import React  from "react";
import { Container, Row, Col, Card, CardBody } from "shards-react";
import { MDBDataTable } from 'mdbreact';
import {firebases } from '../config';
import PageTitle from "../components/common/PageTitle";
import RowImages from "../components/common/RowImages";
import Actions from "../components/common/Actions";



const baseName = "Bikes";
const firebaseDb = firebases.database().ref().child('Bikes');
const header = [{"field":"name","label":"Name","sort":"asc","type":"TEXT","editType":"text"},{"field":"image","label":"BikeImage","sort":"asc","type":"IMAGE","editType":"file"},{"field":"description","label":"description","sort":"asc","type":"TEXT","editType":"textview"},{"label":"Actions","field":"actions","sort":"asc","width":110,"type":"ACTIONS"}];
let context = null;




class Bikes extends React.Component {

  constructor(props){
    super();
    this.state ={list:[],sourceList:[],
  username: "",
  avatar: "",
  isUploading: false,
  progress: 0,
  avatarURL: ""};

  context = this;
  
   this.getListFromDb = this.getListFromDb.bind(this);
}

componentDidMount(){

  this.getListFromDb();

}


getListFromDb(){

  firebaseDb.on('value', snap => {
    
    let dbList = [];
    let sourceList = [];
    console.log(snap);
    snap.forEach(shot => {

      let row = {};
      header.forEach(function(prop){


        if(prop.type==="IMAGE"){
          row[prop.field] = <RowImages src={shot.val()[prop.field]}/>;
        }
        else if(prop.type==="ACTIONS"){
          row[prop.field] = <Actions id={shot.key} baseName={baseName} firebaseDb={firebaseDb} />;
        }
        else{
          row[prop.field] = shot.val()[prop.field];
        }


      });

      dbList.push(row);
      sourceList.push({ ...shot.val(), key: shot.key });
    });


    context.setState({list: dbList.reverse()}); 
    context.setState({sourceList: sourceList}); 


  });
}





  render() {

   const {list} = this.state;
return(  <Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Bikes" subtitle="All Bikes" className="text-sm-left" showAddNew={true} baseName={baseName} />
  
    </Row>

    {/* Default Light Table */}
    <Row>
      <Col>
        <Card small className="mb-4">
       {/*    <CardHeader className="border-bottom">
            <h6 className="m-0">Active Users</h6>
          </CardHeader> */}
          <CardBody className="p-3 pb-3">
          <MDBDataTable scrollY scrollX
          maxHeight="40vh"
      striped
      bordered
      hover
      data={{columns:header,rows:list}}
    />
          </CardBody>
        </Card>
      </Col>
    </Row>

    
  </Container>
);
}

}

export default Bikes;
